export var AdminTransferTransactionStatusType;
(function (AdminTransferTransactionStatusType) {
    AdminTransferTransactionStatusType[AdminTransferTransactionStatusType["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    AdminTransferTransactionStatusType[AdminTransferTransactionStatusType["SUCCESSFUL"] = 2] = "SUCCESSFUL";
    AdminTransferTransactionStatusType[AdminTransferTransactionStatusType["FAIL"] = 3] = "FAIL";
    AdminTransferTransactionStatusType[AdminTransferTransactionStatusType["ROLLBACK"] = 4] = "ROLLBACK";
    AdminTransferTransactionStatusType[AdminTransferTransactionStatusType["ERROR"] = 6] = "ERROR";
})(AdminTransferTransactionStatusType || (AdminTransferTransactionStatusType = {}));
//# sourceMappingURL=AdminTransferTransactionStatusType.js.map